module.exports = __webpack_public_path__ + "static/img/RAPZ2-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPZ2-G_1.png
// module id = SW4c
// module chunks = 0